<template>
  <button
    :title="$t('sharing.facebook')"
    type="button"
    class="facebook"
    @click="share"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      class="h-full w-full"
      viewBox="0 0 30 30"
    >
      <rect
        width="29.5"
        height="29.5"
        x=".3"
        y=".3"
        stroke="#fff"
        stroke-width=".5"
        rx="14.8"
      />
      <path
        fill="#fff"
        d="M17.5 29.5V18.3h3.8l.5-4.4h-4.3V11c0-1.3.4-2.1 2.2-2.1H22V5a31 31 0 0 0-3.4-.1c-3.3 0-5.6 2-5.6 5.8v3.2H9.2v4.4H13v11.2h4.5z"
      />
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  methods: {
    share() {
      this.$store.dispatch('tracking/trackGeneric', {
        category: 'sharing',
        action: 'facebook',
        label: this.text,
      })
      const url = `https://www.facebook.com/sharer.php?u=${encodeURI(this.url)}`
      window.open(url, '_blank', 'width=500,height=400')
    },
  },
}
</script>
